import i18n from '@/i18n'
export default [{
  path: 'order',
  component: () =>
    import('@/views/modules/order/index'),
  name: 'order',
  meta: { title: '订单管理', needToken: true },
  children: [{
    path: 'createOrder',
    component: () =>
      import('@/views/modules/order/orderCreate3'),
    name: 'createOrder',
    meta: { title: i18n.t('route.createOrder'), needToken: true, hideFooter: true }
  },
  {
    path: 'orderDetail/:id',
    component: () =>
      import('@/views/modules/order/orderDetail2'),
    name: 'orderDetail',
    meta: { title: i18n.t('route.orderDetail'), needToken: true }
  },
  {
    path: 'orderPay',
    component: () =>
      import('@/views/modules/order/orderPay'),
    name: 'orderPay',
    meta: { title: '订单支付', needToken: true }
  },
  {
    path: 'enterpriseTransferPayment',
    component: () =>
      import('@/views/modules/order/enterpriseTransferPayment'),
    name: 'enterpriseTransferPayment',
    meta: { title: '企业转账支付', needToken: true }
  },
  {
    path: 'orderPaySuccess',
    component: () =>
      import('@/views/modules/order/orderPaySuccess'),
    name: 'orderPaySuccess',
    meta: { title: '订单支付成功', needToken: true }
  },
  {
    path: 'paySuccess',
    component: () =>
      import('@/views/modules/order/paySuccess'),
    name: 'paySuccess',
    meta: { title: '订单支付成功', needToken: true }
  },
  {
    path: 'shipmentDetail',
    component: () =>
      import('@/views/modules/order/shipmentDetail'),
    name: 'shipmentDetail',
    meta: { title: '发货单', needToken: true }
  },
  {
    path: 'orderEvaluate',
    component: () =>
      import('@/views/modules/order/orderEvaluate'),
    name: 'orderEvaluate',
    meta: { title: '订单评价', needToken: true }
  },
  {
    path: 'orderEvaluateDetail',
    component: () =>
      import('@/views/modules/order/orderEvaluateDetail'),
    name: 'orderEvaluateDetail',
    meta: { title: '订单评价', needToken: true }
  }
  ]
},
// 工业saas
{
  path: 'rdms',
  component: () =>
    import('@/views/modules/saas/rdms'),
  name: 'rdms',
  meta: { title: '远程管家', needToken: false }
},
{
  path: 'saasIndex',
  component: () =>
    import('@/views/modules/saas/index'),
  name: 'saasIndex',
  meta: { title: 'SaaS首页', needToken: false }
},
{
  path: 'saasList',
  component: () =>
    import('@/views/modules/saas/saasList'),
  name: 'saasList',
  meta: { title: 'saas商品列表', needToken: false }
},
{
  path: 'createRdmsOrder',
  component: () =>
    import('@/views/modules/order/sass/orderCreate'),
  name: 'createRdmsOrder',
  meta: { title: '创建订单', needToken: false }
},
{
  path: 'rdmsOrderDetail/:id',
  component: () =>
    import('@/views/modules/order/sass/orderDetail'),
  name: 'rdmsOrderDetail',
  meta: { title: '订单详情', needToken: false }
}
]
